import { sendStats } from './stats';
import { contest } from './initializeStats';
import { scrollToEvent } from './helpers';

export const anchors = function () {
  const initSlug = document.location.pathname.split('/').pop()
      || document.querySelectorAll('.__js_stats_wrapper')[0].getAttribute('id');
  contest.activeSlug = initSlug;
  const customOffset = 90;
  // const customOffset = parseInt(getComputedStyle(document.documentElement)
  //   .getPropertyValue('--header-height'));
  const sections = document.querySelectorAll('.__js_stats_wrapper');
  let wp_content_selector;
  const animationTime = 800;
  let sectionScrollCheckTS = null;
  let reportSlugTS = -1;

  const reportSlug = function () {
    if (contest.lastReportedSlug === null) {
      // wyślij statystykę pageview standard
      // console.log('statData[contest.activeSlug]', statData);

      wp_dot_addparams.ctags = statData[contest.activeSlug].tags;
      WP.push(() => {
        WP.pwp.viewPage({
          ga: {
            event: 'pageview',
            page: {
              pageviewType: 'standard',
              error404: basicStatData.ga.page.error404,
              templateType: 'AS',
            },
            site: {
              name: basicStatData.ga.site.name,
              version: basicStatData.ga.site.version,
              cms: basicStatData.ga.site.cms,
              as: {
                orderId: asorderid,
                productName: asproduct,
                name: asname,
              },
            },
            content: {
              title: statData[contest.activeSlug].title,
              category: {
                IAB: statData[contest.activeSlug].category.IAB,
                Gemius: statData[contest.activeSlug].category.Gemius,
              },
              tags: statData[contest.activeSlug].tags,
            },
          },
        });
      });
    } else {
      // wyślij statystykę pageview scrolboost vpv. pageviewType ma wartość "overlay"
      // gdy nie mamy doładowania i "scrollboost" gdy następuje doładowanie, ALE dla pseudo dynamicznych stron AS ma byc jednak scrollboost ;) - ustalone z Salestube !
      wp_content_selector = document.getElementById(contest.lastReportedSlug);

      contest.unloadData(contest.lastReportedSlug);

      wp_dot_addparams.ctags = statData[contest.activeSlug].tags;
      WP.push(() => {
        WP.pwp.viewPage({
          ga: {
            event: 'pageviewVpv',
            page: {
              pageviewType: 'scrollboost',
              error404: basicStatData.ga.page.error404,
              templateType: 'AS',
            },
            site: {
              name: basicStatData.ga.site.name,
              version: basicStatData.ga.site.version,
              cms: basicStatData.ga.site.cms,
              as: {
                orderId: asorderid,
                productName: asproduct,
                name: asname,
              },
              frontendPlatform: 'other',
            },
            content: {
              title: statData[contest.activeSlug].title,
              category: {
                IAB: statData[contest.activeSlug].category.IAB,
                Gemius: statData[contest.activeSlug].category.Gemius,
              },
              tags: statData[contest.activeSlug].tags,
            },
            // "content": statData[contest.activeSlug]
          },
        });
      });
    }

    contest.lastReportedSlug = contest.activeSlug;
    reportSlugTS = -1;
  };

  const changeActiveSlug = function (slug) {
    contest.activeSlug = slug;
    if (document.location.search.length > 0) {
      history.pushState(
        {
          id: slug,
        },
        slug,
        slug + document.location.search,
      );
      if (document.querySelector('title')) {
        document.querySelector('title').innerText = `${statData[contest.activeSlug].title} - ${defaultSiteTitle}`;
      }
      if (document.querySelector('meta[property="og:title"]')) {
        document.querySelector('meta[property="og:title"]').content = `${statData[contest.activeSlug].title} - ${defaultSiteTitle}`;
      }
      if (document.querySelector('meta[name="twitter:title"]')) {
        document.querySelector('meta[name="twitter:title"]').content = `${statData[contest.activeSlug].title} - ${defaultSiteTitle}`;
      }
    } else {
      history.pushState(
        {
          id: slug,
        },
        slug,
        slug,
      );
      if (document.querySelector('title')) {
        document.querySelector('title').innerText = `${statData[contest.activeSlug].title} - ${defaultSiteTitle}`;
      }
      if (document.querySelector('meta[property="og:title"]')) {
        document.querySelector('meta[property="og:title"]').content = `${statData[contest.activeSlug].title} - ${defaultSiteTitle}`;
      }
      if (document.querySelector('meta[name="twitter:title"]')) {
        document.querySelector('meta[name="twitter:title"]').content = `${statData[contest.activeSlug].title} - ${defaultSiteTitle}`;
      }
    }

    if (contest.lastReportedSlug === null) {
      // jeżeli pierwsze wejście to wysyłaj pageview od razu
      reportSlug();
    } else if (contest.lastReportedSlug !== slug) {
      // jeżeli zmiana sluga to wysyłaj po sekundzie statystykę

      if (reportSlugTS > -1) clearTimeout(reportSlugTS);
      reportSlugTS = setTimeout(reportSlug, 1000);
    } else if (reportSlugTS > -1) clearTimeout(reportSlugTS);
  };

  /* Sprawdzanie czy user zescrollował do sekcji. Jeżeli tak to ustawia pozycję w nawigacji */
  const sectionScrollCheck = function () {
    sectionScrollCheckTS = setTimeout(sectionScrollCheck, 200);

    const topScroll = document.querySelector('body').getBoundingClientRect().top === 0 ? 0 : -(document.querySelector('body').getBoundingClientRect().top);

    // wymuszenie strony głównej
    if (
      topScroll <= customOffset
        && document.location.pathname.split('/').pop().length < 1
    ) {
      changeActiveSlug(sections[0].getAttribute('id'));
      return;
    }

    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      // const sectionOffset = section.getBoundingClientRect().top;
      const sectionOffset = section.offsetTop;
      const sectionHeight = section.getBoundingClientRect().height;
      // console.info(i, topScroll, sectionOffset, sectionOffset + sectionHeight);
      if (
        contest.activeSlug !== section.getAttribute('id')
          && topScroll > sectionOffset - customOffset - 10
          && topScroll < sectionOffset + sectionHeight - customOffset - 10
      ) {
        // console.info(i, topScroll, sectionOffset, sectionOffset + sectionHeight);
        changeActiveSlug(section.getAttribute('id'));
        break;
      }
    }
  };

  /* Inicjalizacja metod dla obsługi nawigacji - clików i sprawdzanie scrolla */
  const initNavigation = function () {
    sectionScrollCheckTS = setTimeout(sectionScrollCheck, animationTime + 25);

    document.querySelectorAll('[data-slug]').forEach((el) => {
      el.addEventListener(
        'click',
        (e) => {
          // console.log('click');
          if (sectionScrollCheckTS) clearTimeout(sectionScrollCheckTS);

          e.preventDefault();
          let slug = el.getAttribute('data-slug');
          if (!slug.length) slug = '/';

          changeActiveSlug(slug);
          contest.isScrollingController(true);
          scrollToEvent(document.querySelector(`#${slug}`).getBoundingClientRect().top + window.scrollY - customOffset, () => {
            document.querySelector('.header').classList.remove('header--translated');
            contest.isScrollingController(false);
          });
          // window.scrollTo({ top: document.querySelector(`#${slug}`).getBoundingClientRect().top + window.scrollY - customOffset, behavior: 'smooth' });
          // document.querySelector(`#${slug}`).scrollIntoView({
          //   behavior: 'smooth',
          // });
          sectionScrollCheckTS = setTimeout(
            sectionScrollCheck,
            animationTime + 25,
          );
        },
      );
    });
  };

  const scrollOnStart = function () {
    if (document.querySelector(`#${initSlug}`)) {
      // document.querySelector(`#${initSlug}`).scrollIntoView({
      //   behavior: 'smooth',
      // });
      contest.isScrollingController(true);
      scrollToEvent(document.querySelector(`#${initSlug}`).getBoundingClientRect().top + window.scrollY - customOffset, () => {
        document.querySelector('.header').classList.remove('header--translated');
        contest.isScrollingController(false);
      });
      // console.log('scroll');
    }

    sendStats('progress', 'start', initSlug);

    changeActiveSlug(initSlug);
    initNavigation();
  };
  // staty pageviews i scrollboost pwp ----- {

  if (initSlug.length > 1) {
    setTimeout(scrollOnStart, 600);
  }
};
